import { default as create, StateCreator } from 'zustand'
import { Instance, getSnapshot, onPatch, onAction } from 'mobx-state-tree'
import { Root as RootModel } from 'src/api/stores/Root'
import { Project } from 'src/api/models/Project'
import { default as testData } from './data/defaultProject'
import { persist } from 'mst-persist'

type ApiRoot = Instance<typeof RootModel>

// if (typeof window !== 'undefined') {
//   const localStore = window.localStorage.getItem('rootStore')
//   if (localStore) {
//     hydratedStore = JSON.parse(localStore)
//     // console.log(hydratedStore)
//   }
// }

// const persitor = new Promise<void>(res => {
//   res()
// })
const defaultProject = getSnapshot(Project().create(testData))
let hydratedStore = { projects: { [defaultProject.id]: defaultProject } }
const store = RootModel.create(hydratedStore)
if (typeof window !== 'undefined' && window.localStorage) {
  const persistor = persist('rootStore', store, {
    storage: window.localStorage
  })
  store.setLoaded(persistor)
}
// else {
//   const project = getSnapshot(Project().create(testData))
//   store.projects.set(project.id, project)
// }
// }
// onAction(store, call => {
//   console.dir('Action was called: ', call)
// })
// onPatch(store, patch => {
//   console.log('got change:', patch)
// })

const setupApi: StateCreator<ApiRoot> = (set, get) => {
  // console.log('API LOADING', store)
  return store
}

export const useApi = create(setupApi)
export const api = useApi
